import getKbbTradeIns from './getKbbTradeIns.js';
import updateWalletStorage from './updateWalletStorage.js';
import validatePaymentsInfo from './validatePaymentsInfo.js';
import debugWallet from './debugWallet.js';
async function buildKbbTradeIns(_ref) {
  let {
    pixAllId,
    myWalletConfigs,
    tradeInFetcher,
    walletStorageService,
    paymentsInfo,
    cbhTradeIns,
    blockTradeInFetch
  } = _ref;
  // fetch
  const tradeIns = await getKbbTradeIns({
    blockTradeInFetch,
    cbhTradeIns,
    tradeInFetcher,
    pixAllId,
    debug: false
  });
  debugWallet('KBB Trade-ins:', tradeIns);
  if (tradeIns?.length > 0) {
    // check to see if there is new trade in data compared to current valuationHistory, if not equal there is a new valuation
    const hasNewTradeIn = tradeIns[0]?.valuationDate !== paymentsInfo?.tradeIn?.valuationDate;
    debugWallet('KBB Trade-ins > Has new trade in?', hasNewTradeIn);
    if (hasNewTradeIn) {
      // validate payments info
      validatePaymentsInfo(paymentsInfo, myWalletConfigs);

      // update wallet storage
      updateWalletStorage({
        walletStorageService,
        currentPaymentsInfo: paymentsInfo,
        payload: {
          tradeIn: tradeIns
        },
        shouldSetLastUpdated: false
      });
      return {
        valuationHistory: tradeIns,
        hasNewTradeIn
      };
    }
  }
  return {};
}
export { buildKbbTradeIns as default };
